import { useTranslations } from 'next-intl';
import type { ComponentProps } from 'react';
import { LotteryStageTemplate } from '../../AreaComponent/templates/LotteryStageTemplate/LotteryStageTemplate';

type HomePageStageProps = ComponentProps<'section'>;

const NAMESPACE = 'home.stage';

function HomePageStageSection({ ...props }: HomePageStageProps) {
  const t = useTranslations(NAMESPACE);

  return (
    <section data-track-container="Discover Lotto" {...props}>
      <h4 className="mb-5">{t('title')}</h4>
      <LotteryStageTemplate lotteryName="euroMillionsPlus" namespace={NAMESPACE} data-testid="home-page-stage" />
    </section>
  );
}

export { HomePageStageSection };
